import { EKioskRouterNames } from '@/types';

/**
 * Checks if the current application context is a Kiosk.
 * It determines this by checking if the current URL pathname starts with the Kiosk route prefix.
 * @returns True if the current path is within the kiosk section, false otherwise.
 */
export const checkIsKiosk = () =>
  window.location.pathname.startsWith(EKioskRouterNames.KIOSK);

/**
 * This function generates valid code for the backend
 * @param code - Code from email
 * @param isSign - if this value true, generate code with prefix KIO
 * @returns code for backend
 */
export const generateEmailCodeInKiosk = (
  code: string,
  isSign: boolean = false,
) => {
  const prefix = isSign ? 'KIO' : '';
  return prefix + '00000000000000' + code;
};
